import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fadeIn } from 'src/app/animations';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import * as moment from 'moment';
import { GenericInfoPayloadType } from 'src/app/models/enum/generic-info-payload-type.enum';
import { RequestUpdateInfoPayload } from 'src/app/models/info/request-update-info-payload.model';

@Component({
	selector: 'plain-info',
	templateUrl: './plain-info.component.html',
	styleUrls: ['./plain-info.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss', '../stylesheets/forms-container.scss'],
	animations: [fadeIn(200)]
})
export class PlainInfoComponent implements OnInit, AfterViewInit {

	public payloadType: GenericInfoPayloadType;
	public payload: any;

	public customerPreferences: SettingsPreferences;
	public formsBeingSaved: { [key: number]: boolean } = {};

	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;
	public readonly ButtonIcons = ButtonIcons;
	public readonly GenericInfoPayloadType = GenericInfoPayloadType;
	public readonly self = this;
	public moment = moment;

	constructor(
		private activatedRoute: ActivatedRoute
	) {
		GlobalSettingsService.isJobCompletedStatusVisible = false;
	}

	ngOnInit(): void {
		this.payloadType = this.activatedRoute.snapshot.data.payload?.type;

		switch (this.payloadType) {
			case GenericInfoPayloadType.MassRequestUpdate:
				this.payload = this.activatedRoute.snapshot.data.payload?.payload as RequestUpdateInfoPayload;
				break;

			default:
				this.payload = null;
		}
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

}
